import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '@repo/http';
import { orgTeamList } from '../organization-team-list';
/** @deprecated Use ze-sdk equivalents. See docs/migration/DOMAIN_TO_SDK_MAPPING.md */ export function useDeleteTeam() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (param)=>{
            let { teamId } = param;
            return axios.delete("/v2/team/".concat(teamId));
        },
        onSuccess: async (_res, param)=>{
            let { organization } = param;
            return queryClient.invalidateQueries({
                queryKey: orgTeamList.teamList({
                    organization
                }).queryKey.slice(0, -1)
            });
        }
    });
}
